<main
  class="credit-installment-plans-component"
  [class.desktop]="!(lessThan$ | async)?.sm"
  [class.single-header]="!(lessThan$ | async)?.mobileXL"
  *transloco="let t">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <div class="header">
        <img class="image-banner" src="/assets/banners/installment-plans.png" />
      </div>
      <article class="content-wrapper">
        <section>
          @if (lang !== 'AR') {
            <h1>Discover the Best Credit Card Installment Plans</h1>
            <span
              >Transform your online shopping experience by paying in monthly,
              interest-free installments. Choose your favorite brands at very affordable
              rates, with free shipping across Saudi Arabia, United Arab Emirates and
              Kuwait. Don't wait—get all your favorite items delivered within a few days!
            </span>
            <span
              >You can buy your favorite products now and pay for them over the next 3 to
              12 months, with no extra charges.
            </span>
          } @else {
            <h1>اكتشف أفضل خطط الدفع على أقساط بواسطة بطاقة الإئتمان</h1>
            <span
              >حول تجربة التسوق عبر الإنترنت إلى الدفع على أقساط شهرية من دون فوائد. اختر
              علاماتك التجارية المفضلة بأسعار معقولة جدًا، مع الشحن المجاني عبر المملكة
              العربية السعودية، الإمارات العربية المتحدة والكويت. لا تنتظر - احصل على جميع
              منتجاتك المفضلة في غضون بضعة أيام!
            </span>
            <span></span>
          }

          <span class="fixed-space-64" aria-hidden="true"></span>

          @if (lang !== 'AR') {
            <h1>How it works</h1>
          } @else {
            <h1>كيف تجري هذه العملية</h1>
          }
          <div class="grid">
            <div class="grid-item popsy-card">
              <h2>1</h2>
              @if (lang !== 'AR') {
                <h2>Shop</h2>
                <span
                  >Make any purchase on our website of SAR 1,000 or more with your credit
                  card, from a participant credit card issuer.</span
                >
              } @else {
                <h1>تسوق</h1>
                <span>
                  قم بأي عملية شراء على موقعنا الإلكتروني بقيمة 1000 ريال سعودي أو أكثر
                  باستخدام بطاقتك الائتمانية من مصدر بطاقة ائتمان مشارك.
                </span>
              }
            </div>
            <div class="grid-item popsy-card">
              <h2>2</h2>
              @if (lang !== 'AR') {
                <h2>Receive</h2>
                <span>Receive your items at your home. </span>
              } @else {
                <h1>استلم</h1>
                <span> استلم مشترياتك في منزلك. </span>
              }
            </div>
            <div class="grid-item popsy-card">
              <h2>3</h2>
              @if (lang !== 'AR') {
                <h2>Pay Monthly</h2>
                <span>Contact your bank to convert it to an installment plan. </span>
              } @else {
                <h1>ادفع شهريًا</h1>
                <span> تواصل مع مصرفك لتحويل المبلغ المستحق إلى خطة تقسيط. </span>
              }
            </div>
          </div>

          <span class="fixed-space-64" aria-hidden="true"></span>

          @if (lang !== 'AR') {
            <h1>Supported Banks</h1>
            <span
              >Select your bank below for more information about converting your purchase
              to an installment plan.</span
            >
          } @else {
            <h1>البنوك الشريكة</h1>
            <span
              >اختر مصرفك أدناه لمزيد من المعلومات حول تحويل عملية الشراء إلى خطة تقسيط.
            </span>
          }
          @if (country === 'AE') {
            <div class="bank-grid">
              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://rakbank.ae/wps/portal/retail-banking/cards/info/easy-payment-plan">
                <img class="bank-logo" src="/assets/bank-logos/ae/Rakbank-logo.png" />
                <span class="fixed-space-8" aria-hidden="true"></span>

                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.hsbc.ae/credit-cards/flexi-instalment-plan/">
                <img class="bank-logo" src="/assets/bank-logos/ae/HSBC-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="http://www.adcb.com/personalbanking/offersdisc/sploffers/offers.asp">
                <img class="bank-logo" src="/assets/bank-logos/ae/ADCB-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.citibank.ae/uae/consumer/credit_cards/0epp.htm?icid=AEMMCC10">
                <img class="bank-logo" src="/assets/bank-logos/ae/Citibank-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.emiratesnbd.com/en/deals/credit-installment-plans/">
                <img class="bank-logo" src="/assets/bank-logos/ae/ENBD-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.cbd.ae/personal/cbd-credit-cards-promotion">
                <img
                  class="bank-logo"
                  src="/assets/bank-logos/ae/Commercial-Bank-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.mashreqbank.com/uae/en/personal/cards/cards-services/merchant-services/mashreq-instant-easy">
                <img
                  class="bank-logo"
                  src="/assets/bank-logos/ae/Mashreq-Bank-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.sc.com/ae/credit-cards/the-good-life-privileges/">
                <img
                  class="bank-logo"
                  src="/assets/bank-logos/ae/Standard-Chartered-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.arabbank.jo/mainmenu/home/Consumer-Banking/cards/easy-payment-plan">
                <img class="bank-logo" src="/assets/bank-logos/ae/Arab-Bank-logo.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.sib.ae/home">
                <img
                  class="bank-logo"
                  src="/assets/bank-logos/ae/Sharjah-Islamic-Bank-logo.png" />
                <button class="popsy-button-primary">
                  <span>{{ t('action_contact_now') }}</span>
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.bankfab.com/en-ae/personal/offers/virgin-megastore-epp-offer">
                <img class="bank-logo" src="/assets/bank-logos/ae/FAB.jpg" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>
            </div>
          } @else {
            <div class="bank-grid">
              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.baj.com.sa/en-us/Contact-Us">
                <img class="bank-logo" src="/assets/bank-logos/sa/aljazera.jpg" />
                <span class="fixed-space-8" aria-hidden="true"></span>

                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://anb.com.sa/web/anb">
                <img class="bank-logo" src="/assets/bank-logos/sa/anb.jpg" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.alfransi.com.sa/english/help-support">
                <img class="bank-logo" src="/assets/bank-logos/sa/faransiBank.jpg" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.riyadbank.com">
                <img class="bank-logo" src="/assets/bank-logos/sa/enbd.jpg" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.sabb.com">
                <img class="bank-logo" src="/assets/bank-logos/sa/SABB.jpg" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.alrajhibank.com.sa/en/alrajhi-group/about/contact-us">
                <img class="bank-logo" src="/assets/bank-logos/sa/alrajhi.jpg" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.alahli.com/en-us/Pages/Call-Us.aspx">
                <img class="bank-logo" src="/assets/bank-logos/sa/snb.png" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>

              <a
                target="_blank"
                class="bank-item flex flex-col"
                href="https://www.riyadbank.com/">
                <img class="bank-logo" src="/assets/bank-logos/sa/RYD-Bank.jpg" />
                <button class="popsy-button-primary">
                  {{ t('action_contact_now') }}
                </button>
              </a>
            </div>
          }

          <span class="fixed-space-64" aria-hidden="true"></span>

          @if (lang !== 'AR') {
            <h1>Terms and Conditions:</h1>
            <div class="flex flex-col">
              <span
                >1. Use your credit card to purchase any item on Popsy and enjoy 0%
                interest payments
              </span>
              <span
                >2. Credit card holders are eligible for 0% interest installment plans.
              </span>
              <span>3. No interest. No down payment. </span>
              <span
                >4. Other conditions may apply (as per each bank internal policies).
              </span>
              <span
                >5. There may be a one-time fee depending on the bank. For more
                information, contact your bank.
              </span>
            </div>
          } @else {
            <h1>الشروط والأحكام:</h1>
            <div class="flex flex-col">
              <span
                >1. استخدم بطاقتك الائتمانية لشراء أي منتج من بوبسي واستمتع بالدفع على
                أقساط من دون فوائد.
              </span>
              <span>2. حاملو بطاقات الائتمان مؤهلون للدفع على أتقساط من دون فوائد. </span>
              <span>3. لا فوائد، ولا دفعة أولى. </span>
              <span>4. قد تطبق شروط أخرى (وفقًا للسياسات الداخلية لكل مصرف). </span>
              <span
                >5. قد تكون هناك رسوم لمرة واحدة فقط حسب المصرف. لمزيد من المعلومات، تواصل
                مع مصرفك.
              </span>
            </div>
          }
        </section>
        <app-other-topics></app-other-topics>
      </article>
      @if ((lessThan$ | async)?.mobileL !== true) {
        <span class="fixed-space-64" aria-hidden="true"></span>
      }
      @if (!(inFullScreenMode$ | async)) {
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      }
    </div>
  </div>
</main>
